<template>
  <el-dialog
    :title="model.id > 0 ? '编辑地址' : '新增地址'"
    :visible.sync="visible"
    width="700px"
    @close="$emit('update:show', false)"
  >
    <el-form
      size="small"
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
    >
      <el-form-item label="地区" size="small" prop="area">
        <el-cascader
          style="width: 100%"
          size="small"
          class="long"
          :options="regionData"
          v-model="model.area"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" size="small" prop="detail">
        <el-input
          size="small"
          v-model="model.detail"
          placeholder="请输入详细地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="收货人" size="small" prop="contact_name">
        <el-input
          size="small"
          v-model="model.contact_name"
          placeholder="请输入收货人姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号码" size="small" prop="contact_phone">
        <el-input
          size="small"
          v-model="model.contact_phone"
          placeholder="请输入手机号码"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { regionData } from '@/util/area_tool'
import { createAddress, updateAddress } from '@/service/getData'
import auth from '@/util/auth'
import { hasAuth } from '@/permission'
import { clone } from '@/util'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      auth,
      visible: this.show,
      regionData: regionData,
      rules: {
        area: [{ required: true, message: '请选择地区' }],
        detail: [{ required: true, message: '请填写详细地址' }],
        contact_name: [{ required: true, message: '请填写收货人姓名' }],
        contact_phone: [{ required: true, message: '请填写收货人手机号' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = clone(this.model)
          let area = data.area
          if (area.length > 0) {
            data.province = area[0]
          }
          if (area.length > 1) {
            data.city = area[1]
          }
          if (area.length > 2) {
            data.county = area[2]
          }

          if (data.id > 0) {
            let res = await updateAddress(data)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createAddress(data)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.el-autocomplete {
  width: 100%;
}
</style>